"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendEmptyPair = exports.ensureAnEmptyPair = exports.remove = exports.updateValue = exports.updateKey = exports.associativeListToDictionary = exports.dictionaryToAssociativeList = void 0;
const lodash_1 = require("lodash");
const EMPTY_PAIR = { key: '', value: '' };
const toDictionaryEntry = (value, key) => ({
    key,
    value,
});
exports.dictionaryToAssociativeList = (obj) => lodash_1.map(obj, toDictionaryEntry);
class OrderedObject {
    constructor() {
        this.data = new Map();
    }
    get(_target, key) {
        return this.data.get(key);
    }
    set(target, key, val) {
        this.data.set(key, val);
        target[key] = val;
        return true;
    }
    has(_target, key) {
        return this.data.has(key);
    }
    ownKeys(_target) {
        return Array.from(this.data.keys());
    }
    getOwnPropertyDescriptor(_target, key) {
        return Object.getOwnPropertyDescriptor(_target, key);
    }
}
exports.associativeListToDictionary = (list) => {
    const accum = new Proxy({}, new OrderedObject());
    const dictionary = lodash_1.reduce(list, (dict, { key, value }) => {
        dict[key] = value;
        return dict;
    }, accum);
    return Object.freeze(dictionary);
};
exports.updateKey = (list, indexToUpdate, newKey) => lodash_1.map(list, (pair, index) => index === indexToUpdate ? { key: newKey, value: pair.value } : pair);
exports.updateValue = (list, indexToUpdate, newValue) => lodash_1.map(list, (pair, index) => index === indexToUpdate ? { key: pair.key, value: newValue } : pair);
exports.remove = (list, indexToRemove) => {
    const updated = lodash_1.filter(list, (_pair, index) => index !== indexToRemove);
    return !lodash_1.isEmpty(updated) ? updated : [EMPTY_PAIR];
};
exports.ensureAnEmptyPair = (dictionary) => {
    if (!lodash_1.isEmpty(dictionary) && !lodash_1.isObject(dictionary)) {
        return { '': lodash_1.toString(dictionary) };
    }
    return lodash_1.isEmpty(dictionary) ? { '': '' } : dictionary;
};
exports.appendEmptyPair = (list) => [
    ...list,
    EMPTY_PAIR,
];
